// Interfaces
import { IBaseCertificationContainerProps } from './interfaces'

const BaseCertificationContainer = ({ children, ...rest }: IBaseCertificationContainerProps) => {
  return (
    <div {...rest} className={`px-2 xl:px-16 2xl:px-40 lg:py-5 ${rest.className ? rest.className : ''}`}>
      {children}
    </div>
  )
}

export { BaseCertificationContainer }
